import {
  DEV_CONFIG
} from './config_dev'
import {
  PRO_CONFIG
} from './config_master'
import {
  UAT_CONFIG
} from './config_uat'
let babelEnv = process.env.BABEL_ENV
console.log(babelEnv)
let APP_CONFIG = {}
if (babelEnv === 'uat') { // 测试环境
  APP_CONFIG = UAT_CONFIG
} else if (babelEnv === 'prod') { // 生产环境
  APP_CONFIG = PRO_CONFIG
} else if (babelEnv === 'dev') { // 本地开发环境
  APP_CONFIG = DEV_CONFIG
}

export default APP_CONFIG



// WEBPACK FOOTER //
// ./src/api/index.js